// const APP_ID = '2078185441880629236';
const APP_ID = import.meta.env.VITE_APP_ID

export default Object.freeze({
  /**
   * Zalo Mini App ID
   */
  appId: APP_ID,
  zaloOA: '2138185689813256716',
  swood_zmp: `swood_zmp|app_id:${APP_ID}`,
  swood_train_zone: `swood_train_zone|app_id:${APP_ID}`
})
